import { useNavigate } from 'react-router-dom';
import logo from "@/assets/images/logo.png";
export function CompletionMessage() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-[#eae5d6] flex flex-col items-center justify-center p-6 text-center">
      <div className="mb-12">
        <div className="flex justify-center mb-6">
              <img src={logo} alt="PostScrypt Logo" className="h-16 w-auto" />
            </div>
      </div>
      
      <h2 className="text-[#FF6B4A] text-3xl font-medium mb-8">
        Thank you for completing the<br />initial questionnaire!
      </h2>
      
      <p className="text-gray-900 text-3xl mb-8">
        Please hand the tablet back to<br />your advisor.
      </p>
      
      <div className="max-w-md">
        <p className="text-gray-600 text-base">
          An email has been sent to the email address provided.<br />
          When you&apos;re ready to continue your <span className="font-bold">PostScrypt</span> journey,<br />
          simply click on the link in the email.
        </p>
      </div>
      
      <button 
        onClick={() => navigate('/')}
        className="mt-12 bg-[#FF6B4A] text-white px-8 py-3 rounded-full hover:bg-[#E55D3D] transition-colors flex items-center gap-2"
      >
        Continue
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.75 6.75L19.25 12L13.75 17.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M19 12H4.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
} 